"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.promise");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("regenerator-runtime/runtime");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mobxReact = require("mobx-react");

var _Spinner = _interopRequireDefault(require("@icare/components/lib/Spinner"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _isContentMap = function _isContentMap(n) {
  return n && _typeof(n) === 'object' && typeof n.inject === 'string' && typeof n.as === 'string';
};

var _isContentComputed = function _isContentComputed(n) {
  return n && typeof n === 'function';
};

var _isContentId = function _isContentId(n) {
  return n && typeof n === 'string';
};
/**
 * WithContent is a HOC that is responsible for injecting a given
 * component with the content it requires. It works by creating a new
 * component and using that component to ask the content store for all
 * the required data. It then provides that data as props to the original
 * component.
 * @param {ReactNode}      Component      - the component we wish to inject into
 * @param {Array<String>}  contentIds     - An array of content ID strings, mapping to the keys of the content store object
 * @param {Array<String>}  contentAreaIds - An array of content area ID strings, mapping to the keys of the content store object
 */


var withContent = function withContent(Component, contentIds) {
  var _class, _temp;

  var contentAreaIds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return (0, _mobxReact.inject)('contentStore')((_temp = _class = /*#__PURE__*/function (_React$Component) {
    _inherits(ComponentWithContent, _React$Component);

    var _super = _createSuper(ComponentWithContent);

    function ComponentWithContent(props) {
      var _this;

      _classCallCheck(this, ComponentWithContent);

      _this = _super.call(this, props);

      _defineProperty(_assertThisInitialized(_this), "_updateContent", function () {
        _this.updateContent();
      });

      _defineProperty(_assertThisInitialized(_this), "_forceUpdateContent", function () {
        _this.props.contentStore.clearContent();

        _this.updateContent();
      });

      var contentIdMaps = contentIds.filter(function (c) {
        return _isContentMap(c);
      });
      var contentAreaMaps = contentAreaIds.filter(function (c) {
        return _isContentMap(c);
      });
      _this._contentMaps = [].concat(_toConsumableArray(contentIdMaps), _toConsumableArray(contentAreaMaps));
      _this._contentIds = [].concat(_toConsumableArray(contentIds.filter(function (c) {
        return _isContentId(c);
      })), _toConsumableArray(contentIdMaps.map(function (m) {
        return m.inject;
      })));
      _this._computed = contentIds.filter(function (c) {
        return _isContentComputed(c);
      });
      _this._contentAreaIds = [].concat(_toConsumableArray(contentAreaIds.filter(function (ca) {
        return _isContentId(ca);
      })), _toConsumableArray(contentAreaMaps.map(function (m) {
        return m.inject;
      })));
      _this._computedContentAreas = contentAreaIds.filter(function (ca) {
        return _isContentComputed(ca);
      });
      _this.state = {
        isLoading: true,
        content: null
      };
      return _this;
    }

    _createClass(ComponentWithContent, [{
      key: "updateContent",
      value: function () {
        var _updateContent = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var _this2 = this;

          var contentStore, contentMaps, ids, caIds;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  contentStore = this.props.contentStore; // Clone these so we are not mutating originals

                  contentMaps = _toConsumableArray(this._contentMaps);
                  ids = _toConsumableArray(this._contentIds);
                  caIds = _toConsumableArray(this._contentAreaIds); // Iterate all computed content

                  this._computed.forEach(function (c) {
                    (function process(result) {
                      if (Array.isArray(result)) {
                        result.forEach(function (item) {
                          return process(item);
                        });
                      } else {
                        if (_isContentMap(result)) {
                          // If a map, hold onto the map and continue to load the underlying id
                          contentMaps.push(result);
                          ids.push(result.inject);
                        } else if (_isContentId(result)) {
                          // If an id, so load it as per normal
                          ids.push(result);
                        } else {
                          if (result !== null) {
                            console.error('Invalid result. Check the return statement of your computed content function.', c);
                          }
                        }
                      }
                    })(c.call(Component, _this2.props, contentIds, contentAreaIds));
                  }); // Iterate all computed content areas


                  this._computedContentAreas.forEach(function (c) {
                    (function process(result) {
                      if (Array.isArray(result)) {
                        result.forEach(function (item) {
                          return process(item);
                        });
                      } else {
                        if (_isContentMap(result)) {
                          // If a map, hold onto the map and continue to load the underlying id
                          contentMaps.push(result);
                          caIds.push(result.inject);
                        } else if (_isContentId(result)) {
                          // If an id, so load it as per normal
                          caIds.push(result);
                        } else {
                          if (result !== null) {
                            console.error('Invalid result. Check the return statement of your computed content area function.', c);
                          }
                        }
                      }
                    })(c.call(Component, _this2.props, contentIds, contentAreaIds));
                  });

                  _context.next = 8;
                  return contentStore.loadContent(ids, caIds);

                case 8:
                  this.setState({
                    isLoading: false,
                    content: _objectSpread(_objectSpread({}, contentStore.getFlattenedContentForIds([].concat(_toConsumableArray(ids), _toConsumableArray(caIds)), contentMaps)), {}, {
                      update: this._updateContent,
                      forceUpdate: this._forceUpdateContent
                    })
                  });

                case 9:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function updateContent() {
          return _updateContent.apply(this, arguments);
        }

        return updateContent;
      }()
    }, {
      key: "componentDidMount",
      value: function componentDidMount() {
        this.updateContent();
      }
    }, {
      key: "render",
      value: function render() {
        if (this.state.isLoading) {
          return /*#__PURE__*/_react.default.createElement("div", {
            style: {
              paddingTop: '60px'
            }
          }, /*#__PURE__*/_react.default.createElement(_Spinner.default, {
            active: true
          }));
        }

        return /*#__PURE__*/_react.default.createElement(Component, _extends({
          content: this.state.content
        }, this.props));
      }
    }]);

    return ComponentWithContent;
  }(_react.default.Component), _defineProperty(_class, "propTypes", {
    contentStore: _propTypes.default.object.isRequired
  }), _temp));
};

var _default = withContent;
exports.default = _default;
//# sourceMappingURL=withContent.js.map